
import * as THREE from 'three'

class CustomPhongMaterial extends THREE.MeshPhongMaterial{

  constructor(param){
    super(param);

    this.onBeforeCompile = this.overwriteShader;
    this.intiShowThresholdWorldY = 100;
  }

  overwriteShader(shader){

    shader.uniforms.showThreholdWorldY = {type: 'f', value: this.intiShowThresholdWorldY};

    shader.fragmentShader = shader.fragmentShader.replace(useOpacityOnly.key, useOpacityOnly.content);
    
    shader.vertexShader = shader.vertexShader.replace(varyingPosition.key, varyingPosition.content);
    shader.fragmentShader= shader.fragmentShader.replace(varyingPosition.key, varyingPosition.content);

    shader.vertexShader = shader.vertexShader.replace(varyingPositionVertex.key, varyingPositionVertex.content);

    this.userData.shader = shader;
  }

}

const varyingPosition = {
  key: '#define PHONG',
  content: `
  varying vec4 vWorldPosition2;
  uniform float showThreholdWorldY;
  `
}

const varyingPositionVertex = {
  key: '#include <clipping_planes_vertex>',
  content: `
  vWorldPosition2 = modelMatrix * vec4(transformed, 1.0);
  `
}



const useOpacityOnly = {
  key: '#include <envmap_fragment>',
  content: `
 
  if(vWorldPosition2.y > showThreholdWorldY)
    discard;
  `
}
export default CustomPhongMaterial
